var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutosSeminuevoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3.2a4.8 4.8 0 100 9.6 4.8 4.8 0 000-9.6zM11 8a6 6 0 1112 0 6 6 0 01-12 0zm-6 7.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S7.33 17 6.5 17 5 16.33 5 15.5zm13-.57a6.72 6.72 0 002-.6V21c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1H5v1c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1v-8l2.08-5.99C4.29 6.42 4.84 6 5.5 6h4.79c-.19.63-.29 1.31-.29 2H5.85l-1.04 3h5.86c.36.75.84 1.43 1.43 2H4v5h14v-3.07zm-1.09.07a6.918 6.918 0 01-2.53-.51c-.23.27-.38.62-.38 1.01 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.18-.03-.34-.09-.5zm.59-10.5a.5.5 0 00-1 0V5a1.5 1.5 0 000 3h1a.5.5 0 010 1h-1.017a.5.5 0 01-.45-.25.5.5 0 00-.866.5A1.5 1.5 0 0016.5 10v.5a.5.5 0 001 0V10a1.5 1.5 0 000-3h-1a.5.5 0 010-1h1.017a.5.5 0 01.45.25.5.5 0 00.866-.5A1.5 1.5 0 0017.5 5v-.5z",
    fill: "#0A111E"
  })));
}
export default SvgAutosSeminuevoIcon;